export type TMetroIcon = 'base' | 'msk' | 'spb' | 'ekb' | 'kaz' | 'nsk' | 'nn' | 'sam';

/**
 * Иконка метро по региону (`geo.dbAddressIds.locationId`).
 * Порт `UNDERGROUND_ICON_NAME` монолита (`cian/business_shopping_centers/presenters.py`, id — `RealtyRegions`)
 */
export const METRO_ICON_BY_LOCATION_ID: Partial<Record<number, TMetroIcon>> = {
  1: 'msk',
  [-1]: 'msk',
  4593: 'msk',
  2: 'spb',
  [-2]: 'spb',
  4588: 'spb',
  4743: 'ekb',
  4777: 'kaz',
  4897: 'nsk',
  4598: 'nsk',
  4596: 'nn',
  4966: 'sam',
  4608: 'sam',
};
